import React from 'react';
import { Container } from 'react-bootstrap';
import Section from './Section';
import CardRunout from './CardRunout';
import BackgroundSuits from './BackgroundSuits';

const Hero = () => (
  <Section id="home" className="hero-section hero-centered">
    <BackgroundSuits />
    <Container className="d-flex justify-content-center" style={{ position: 'relative', zIndex: 1 }}>
      <CardRunout />
    </Container>
  </Section>
);

export default Hero;
